<template>
  <div style="width: 100%;height: 100%;text-align: center">
    <el-scrollbar style="height: 100%">
      <div style="font-size: 26px;font-weight: bolder;margin-bottom: 1%">曾获科技奖励情况</div>
      <el-table
        :data="tableData"
        border
        :cell-style="{borderColor:'#4a4a4a'}"
        :header-cell-style="{borderColor:'#4a4a4a'}"
        style="width: 100%;margin-top: 15px;">
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="获奖项目名称"
          width="260"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.name" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="awarddate"
          label="获奖时间"
          width="140"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-date-picker
              :readonly="isDisabled"
              v-model="scope.row.awarddate"
              type="date"
              size="small"
              style="width: 130px"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="awardname"
          label="获奖名称"
          align="center"
          width="210"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.awardname" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="awardgrade"
          label="奖励等级"
          align="center"
          width=""
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.awardgrade" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="awardpeople"
          label="主要获奖人（前5名）"
          align="center"
          width="260"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.awardpeople" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="awardunit"
          label="授奖单位"
          align="center"
          width="220"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.awardunit" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isDisabled"
          label="操作"
          align="center"
          show-overflow-tooltip
          width="70">
          <template slot-scope="scope">
            <i class="el-icon-circle-plus-outline" @click="onAddRow(scope.$index)" style="cursor: pointer"></i>
            <i class="el-icon-remove-outline" @click="onDeleteRow(scope.$index)" style="cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: left;">本表可填科技奖励包括:<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、省辖市政府、省直管县（市）或省直有关部门设立的科学技术奖；<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、原经科技管理部登记的社会力量设立的科学技术奖。
      </div>
      <div v-if="!isDisabled" style="width: 100%;margin-top: 20px;">
        <el-button :disabled="isSubmit" type="primary" @click="onSubmit">保存</el-button>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
  import utils from "../../js/utils";

  export default {
    name: "AcquiredAward_06",
    data() {
      return {
        createuserid: sessionStorage.getItem('createuserid'),
        isDisabled: sessionStorage.getItem('openWith') == 'readOnly' ? true : false,
        tableData: [{
          name: '',
          awarddate: '',
          awardname: '',
          awardgrade: '',
          awardpeople: '',
          awardunit: '',
          state: false
        }],
        deleteList: [],
        isSubmit: false
      }
    },
    methods: {
      onAddRow(index) {
        this.tableData.splice(index + 1, 0, {
          name: '',
          awarddate: '',
          awardname: '',
          awardgrade: '',
          awardpeople: '',
          awardunit: '',
          state: false
        })
      },
      onDeleteRow(index) {
        if (this.tableData[index].state) {
          this.deleteList.push({aid: this.tableData[index].aid})
        }
        this.tableData.splice(index, 1);
        if (!this.tableData.length) {
          this.tableData.push({
            name: '',
            awarddate: '',
            awardname: '',
            awardgrade: '',
            awardpeople: '',
            awardunit: '',
            state: false
          })
        }
      },
      getData() {
        if (sessionStorage.getItem("pbcid") == undefined) {
          return
        }
        this.$axios({
          method: 'get',
          url: this.GLOBAL.URL + 'pingjiang/common/selectprojectaward',
          params: {
            pbcid: Number(sessionStorage.getItem('pbcid'))
          }
        }).then(res => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            if (resp.data.length) {
              this.tableData = resp.data;
              this.tableData.forEach((item, index) => {
                this.tableData[index].state = true
              });
            }
            this.deleteList = [];
            this.closeLoading();
          } else {
            this.closeLoading();
            this.showFailMsg(resp.message)
          }
        })
      },
      onSubmit() {
        if(this.tableData.length==1 && (this.tableData[0].name==='' && this.tableData[0].awarddate==='' && this.tableData[0].awardname==='' && this.tableData[0].awardgrade==='' && this.tableData[0].awardpeople==='' && this.tableData[0].awardunit==='')) {
          this.openLoading("内容提交中","提交失败，请检查网络",7000);
          this.$axios({
            method: 'post',
            url: this.GLOBAL.URL + 'pingjiang/user/updateprojectaward',
            data: {
              pbcid: Number(sessionStorage.getItem('pbcid')),
              addList: [],
              updateList: [],
              deleteList: this.deleteList,
            }
          }).then((res) => {
            let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
            if (resp.code == 1000) {
              this.showSuccessMsg(resp.message);
              this.getData();
            } else {
              this.showFailMsg(resp.message);
            }
          })
        } else {
          for (let i = 0; i < this.tableData.length; i++) {
            if(this.tableData[i].name===''||this.tableData[i].awarddate===''||this.tableData[i].awardname===''||this.tableData[i].awardgrade===''||this.tableData[i].awardpeople===''||this.tableData[i].awardunit===''){
              this.showNotifyError('请完善表格数据！');
              return ;
            }
          }
          this.openLoading("内容提交中","提交失败，请检查网络",7000);
          let addList = [];
          let updateList = [];
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].state) {
              updateList.push({
                pbcid: Number(sessionStorage.getItem('pbcid')),
                aid: this.tableData[i].aid,
                name: this.tableData[i].name,
                awarddate: this.tableData[i].awarddate,
                awardname: this.tableData[i].awardname,
                awardgrade: this.tableData[i].awardgrade,
                awardpeople: this.tableData[i].awardpeople,
                awardunit: this.tableData[i].awardunit
              })
            } else {
              addList.push({
                pbcid: Number(sessionStorage.getItem('pbcid')),
                name: this.tableData[i].name,
                awarddate: this.tableData[i].awarddate,
                awardname: this.tableData[i].awardname,
                awardgrade: this.tableData[i].awardgrade,
                awardpeople: this.tableData[i].awardpeople,
                awardunit: this.tableData[i].awardunit
              })
            }
          }
          this.$axios({
            method: 'post',
            url: this.GLOBAL.URL + 'pingjiang/user/updateprojectaward',
            data: {
              pbcid: Number(sessionStorage.getItem('pbcid')),
              addList: addList,
              updateList: updateList,
              deleteList: this.deleteList,
            }
          }).then((res) => {
            let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
            if (resp.code == 1000) {
              this.showSuccessMsg(resp.message);
              this.getData();
            } else {
              this.showFailMsg(resp.message);
            }
          })
        }
      },
    },
    created() {
      this.getData()
    },
    mounted() {
      if(sessionStorage.getItem('pbcid')==undefined){
        this.$message.error('请先填写项目基本情况表');
        this.$router.push({
          path:'/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
        })
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-scrollbar__wrap {
    overflow: hidden scroll;
    height: 100%;
  }

  /deep/ .el-table .el-table__cell {
    padding: 0px;
  }

  /deep/ .el-table .cell {
    padding: 5px 3px;
  }

  /deep/ .el-table th.el-table__cell > .cell {
    padding: 16px 5px;
  }

  /deep/ .el-textarea__inner {
    resize: none;
    padding: 0;
    border: none;
  }

  .el-table {
    border: 1px solid #4a4a4a;
  }

  /deep/ .el-input__inner{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/AcquiredAward_06.vue